import {ApiClient} from './apiClient/apiClient';

const apiClient = new ApiClient();

export const getCustomer = () => {
    return apiClient.get(`customer`);
}

export const updateCustomer = (customer) => {
    return apiClient.put(`customer/${customer.id}`, customer);
}
